import Enumerable from "linq";
import { IObjectsReferable } from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectBean, IXElementContentsObjectRelationalBean } from "../../../beans";
import { RelationTranslator } from "./RelationTranslator";
import { ILinkedObjectTranslatable } from "./ILinkedObjectTranslatable";

export class ObjectReferencesTranslator<T> {
  constructor(action: string, private readonly reference: ILinkedObjectTranslatable<T>) {
    this.relationalItems = new RelationTranslator(action);
  }

  from(bean: IXElementContentsObjectBean): IObjectsReferable<T> {
    return this.relationalItems.from(
      bean,
      is => ({
        references: Enumerable.from(is)
          .select(i => this.reference.from(i))
          .where(i => !!i)  // オブジェクト参照変換が無効値を返した場合は間引く.
          .toArray(),
      }),
      {
        references: [],
      });
  }

  to(object: IObjectsReferable<T>): IXElementContentsObjectRelationalBean {
    return this.relationalItems.to(
      Enumerable.from(object.references)
        .select(r => this.reference.to(r))
        .where(i => !!i)  // オブジェクト参照変換が無効値を返した場合は間引く.
        .toArray());
  }

  private readonly relationalItems: RelationTranslator;
}
